//#region src/scripts/extenders/event-handler.js
var EventHandler = class extends HTMLElement {
	constructor() {
		super();
	}
};
if (customElements.get("event-handler") === void 0) customElements.define("event-handler", EventHandler);
//#endregion
